<template>
  <div class="body">
    
  </div>
  
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      major: [],
      ads: []
    };
  },
  mounted: function() {
    // axios
    //   .get(
    //     "https://www.easy-mock.com/mock/5a67ef8cbdf9f5437bb4979a/Data/homedata"
    //   )
    //   .then(response => {
    //     this.major = response.data.major;
    //     this.ads = response.data.ads;
    //   })
    //   .catch(error => {
    //     alert("网络错误不能访问");
    //   });
  },
};
</script>
<style scoped>

</style>






// WEBPACK FOOTER //
// src/components/pages/Support.vue